import { render, staticRenderFns } from "./MenuBarPage.vue?vue&type=template&id=153e2fd5&scoped=true"
import script from "./MenuBarPage.vue?vue&type=script&lang=js"
export * from "./MenuBarPage.vue?vue&type=script&lang=js"
import style0 from "./MenuBarPage.vue?vue&type=style&index=0&id=153e2fd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e2fd5",
  null
  
)

export default component.exports